import { PageRouteConfig } from '@/modules/core/app/helpers/PageRouteConfig';
import { Module } from '@/modules/core/app/constants/app.constants';

export const router = PageRouteConfig.factory(
  [
    {
      path: 'entityforms/order',
      name: 'orderforms',
      component: () =>
        import(/* webpackChunkName: "order-forms-list-page" */ './pages/OrderFormsPage.vue'),
    },
    {
      path: 'entityforms/product',
      name: 'productforms',
      component: () =>
        import(/* webpackChunkName: "products-list-page" */ './pages/ProductsPage.vue'),
    },
    {
      path: 'entityforms/task',
      name: 'taskforms',
      component: () =>
        import(/* webpackChunkName: "task-forms-list-page" */ './pages/TaskFormsPage.vue'),
    },
    {
      path: 'entityforms/client',
      name: 'clientforms',
      component: () =>
        import(/* webpackChunkName: "client-forms-list-page" */ './pages/ClientFormsPage.vue'),
    },
    {
      path: 'entityforms/:formType/:id',
      name: 'entityforms',
      component: () =>
        import(
          /* webpackChunkName: "form-builder-page" */ '../formbuilder/pages/FormBuilderPage.vue'
        ),
      props: true,
    },
    {
      path: 'entityforms/:formType/details/:id/:tabValue?',
      name: 'entityform-details',
      component: () =>
        import(
          /* webpackChunkName: "entityform-details" */ './pages/EntityFormConfigurationDetailsPage.vue'
        ),
      props: true,
    },
    {
      path: '/entityforms/:formType/:id/workflow',
      name: 'workflow-creation',
      component: () =>
        import(
          /* webpackChunkName: "entity-status-set-creation-page" */ '../entitystatus/pages/EntityStatusSetCreationPage.vue'
        ),
      props: true,
    },
  ],
  Module.ENTITYFORM
);
